export default class ApiError extends Error {
	constructor(message, code, status) {
		super(message);
		this.code = code;
		this.name = 'ApiError';
		this.status = status;
	}
}
